import React from 'react'
import {
  Redirect
} from 'react-router-dom'
import PrivateRoute from 'components/PrivateRoute'
import { userIsAdmin } from 'helpers/dataHelpers'


const AdminRoute = ({ ...rest }) => (
    userIsAdmin(rest.userType) ?
      <PrivateRoute {...rest} /> : <Redirect to='/' />
  )

export default AdminRoute
